import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens(store, params) {
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("drp/blacklist", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  },
  async Store(store, params) {
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "drp/blacklist",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  },
  async Delete(store, params) {
    let id = 0;
    if (!params.ids) {
      id = params.id;
    }
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("drp/blacklist/" + id, {
        headers,
        params
      })
      .then(resp => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        localStorage.setItem("token", resp.data.token);
        return resp.data.itens;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  }
};
